export function getCookieValue(name) {
    let cookie;
    try {
        cookie = document.cookie.split('; ').find((row) => row.startsWith(name));
        // eslint-disable-next-line no-unused-vars
    }
    catch (e) {
        return null;
    }
    if (cookie === undefined) {
        return null;
    }
    return cookie.split('=')[1];
}
export function setCookieValue(name, value, options) {
    const cookieOptions = {
        path: '/',
        ...options
    };
    let updatedCookie = `${name}=${value}`;
    for (const optionKey in cookieOptions) {
        if ({}.hasOwnProperty.call(cookieOptions, optionKey)) {
            updatedCookie += `; ${optionKey}`;
            const optionValue = cookieOptions[optionKey];
            if (optionValue !== true) {
                updatedCookie += `=${optionValue}`;
            }
        }
    }
    document.cookie = updatedCookie;
}
